// 曝光打点设置
function createObserve(monitorCb, monitorDom, monitorOption) {

    if (window.IntersectionObserver) {
        //监控配置, 默认设置为0.8
        const OPTION = monitorOption || {
            //出现在屏幕中的阈值
            threshold: 0.8
        };

        const observer = new IntersectionObserver(function (entires) {
            entires.forEach(item => {
                if (item.isIntersecting) {
                    //打点上报,  将曝光的item回传
                    monitorCb(null, item);
                }
            })
        }, OPTION);

        const monitorDomLen = monitorDom.length;
        for (let i = 0; i < monitorDomLen; i++) {
            observer.observe(monitorDom[i]);
        };

        // 将新建的对象返回，便于针对该对象做其他操作，比如去除重复监听
        return observer;

    } else {
        // 不支持该api进行上报
        monitorCb(new Error('不支持IntersectionObserver'));
    }

};

export default createObserve;